var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNobus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 108
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h135v107.277H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E7EE",
    fillRule: "nonzero",
    d: "M86.185 47.081c-1.56 2.56-2.293 5.383-1.02 8.11 1.135 2.435 3.381 3.741 5.989 4.372l10.507-4.874a7.279 7.279 0 019.65 3.518l-.045-.094a7.235 7.235 0 01-3.51 9.625L43.528 97.535a7.277 7.277 0 01-9.652-3.515l.045.096a7.23 7.23 0 013.513-9.625l26.324-12.212c1.168-2.382 1.59-4.922.464-7.333-1.275-2.728-3.911-3.979-6.88-4.432l-8.537 3.974a7.214 7.214 0 01-9.583-3.482 7.2 7.2 0 013.489-9.565l12.95-6.029c1.048-2.29 1.388-4.71.312-7.016-.997-2.136-2.832-3.366-5.005-4.018l-22.12 10.236a7.318 7.318 0 01-9.7-3.54l.074.155a7.254 7.254 0 013.531-9.662L84.345 3.063a7.312 7.312 0 019.695 3.54l-.07-.153a7.264 7.264 0 01.24 5.565 7.262 7.262 0 01-3.775 4.095l-13.423 6.215c-.864 2.052-1.078 4.214-.097 6.317 1.079 2.306 3.152 3.602 5.584 4.27l18.155-8.456a7.217 7.217 0 019.586 3.481 7.198 7.198 0 01-3.493 9.568l-20.562 9.574v.002z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#9AB1D1",
    strokeWidth: 1.671
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M108.595 20.089c0-2.71-2.248-4.908-5.022-4.908a5.034 5.034 0 00-4.547 2.82 2.778 2.778 0 00-1.594-.498c-1.487 0-2.69 1.14-2.69 2.543.001.202.027.405.077.601a3.728 3.728 0 00-2.967 3.649c0 2.058 1.671 3.625 3.733 3.625h12.245c1.972 0 3.572-1.647 3.572-3.8 0-1.87-1.203-3.427-2.807-3.808v-.224h0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M88.565 24.379h9.432m6.582-4.216h8.958"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#9AB1D1",
    strokeWidth: 1.671
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M40.551 32.424c0-1.998-1.714-3.615-3.829-3.615-1.53 0-2.85.848-3.461 2.075a2.171 2.171 0 00-1.217-.368c-1.129 0-2.048.842-2.048 1.875 0 .153.023.3.06.447a2.774 2.774 0 00-2.262 2.687c0 1.513 1.273 2.673 2.847 2.673h9.322c1.504 0 2.72-1.217 2.72-2.804a2.84 2.84 0 00-2.139-2.806l.007-.164h0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M25.292 35.588h7.183m4.889-3.054h6.826"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.192 65.767)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.038,
    cy: 9.048,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#9AB1D1",
    strokeWidth: 1.671,
    rx: 9.038,
    ry: 9.048
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE3F2",
    fillRule: "nonzero",
    d: "M10.772 1.587a7.675 7.675 0 010 14.922 8.641 8.641 0 000-14.922z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9AB1D1",
    strokeLinecap: "round",
    strokeWidth: 1.671,
    d: "M9.038 12.927v23.272"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#9AB1D1",
    strokeLinecap: "round",
    strokeWidth: 1.671,
    d: "M10.192 103.133h114.879"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.19 39.249)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#9AB1D1",
    strokeWidth: 1.675,
    d: "M8.218 10.999h52.04a8.218 8.218 0 018.218 8.218V63.69h0H0V19.217A8.217 8.217 0 018.218 11z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.142,
    cy: 8.905,
    r: 8.611,
    fill: "#FFF",
    stroke: "#9AB1D1",
    strokeWidth: 1.675
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#9AB1D1",
    fontFamily: "Quicksand-Bold, Quicksand",
    fontSize: 13.56,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.701,
    y: 14.091
  }, "B")), /*#__PURE__*/React.createElement("path", {
    stroke: "#9AB1D1",
    strokeLinecap: "square",
    strokeWidth: 1.675,
    d: "M1.901 20.909h65.81M1.587 42.965h66.889"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9AB1D1",
    strokeWidth: 1.675,
    d: "M6.9 25.807h20.695c.186 0 .337.151.337.337v8.352a.337.337 0 01-.337.338H6.9a.338.338 0 01-.338-.338v-8.352c0-.186.151-.337.338-.337zm35.569 0h20.693c.187 0 .338.151.338.337v8.352a.338.338 0 01-.338.338H42.47a.338.338 0 01-.338-.338v-8.352c0-.186.151-.337.338-.337z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9AB1D1",
    strokeLinecap: "round",
    strokeWidth: 1.675,
    d: "M35.142 20.909v41.629"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.299,
    height: 5.708,
    x: 22.091,
    y: 40.334,
    fill: "#FFF",
    stroke: "#9AB1D1",
    strokeWidth: 1.675,
    rx: 2.854
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#9AB1D1",
    strokeWidth: 1.675
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M104.025 78.017v23.833"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M98.523 81.578l-2.247 2.618 2.247 2.618h13.251v-5.236zm11.004 13.809l2.247-2.618-2.247-2.618H96.276v5.236z"
  })))));
}
export default SvgNobus;